import { useState, useRef } from "react";
import moment from "moment";
import { toast } from "react-toastify";

import { TextBadge } from "../common";
import GenericSelectableTable from "../selectableTable";
import useApi from "../../api";
import enumChoice, { getEnumLabel } from "../../enum";
import OrderDetails from "../orders/orderDetails";
import ReturnOrderDetails from "./returnOrderDetails";



function ReturnRequestTable({ fetchReturnRequest, returnRequests }: any) {
  const api = useApi();
  const [openOrderDetails, setOpenOrderDetails] = useState<any>(null);
  const [openReturnOrderDetails, setOpenReturnOrderDetails] = useState<any>(null);
  const printRef = useRef<HTMLDivElement>(null);


  const bullkActionButtons = [
    {
      label: 'Approve Selected',
      onClick: (selectedItems:any) => {
        const payload = {
          status: enumChoice.returnStatuses.toKV().APPROVED.value,
          request_ids: Array.from(selectedItems),
        }
        api.updateReturnRequesStatusBulk(payload).then((response) => {
          toast.success("Return request status updated successfully");
          fetchReturnRequest();
        }, (error) => {
          toast.error("Failed to update return request status");
        })

      },
    },
    {
      label: 'Reviewed Selected',
      onClick: (selectedItems:any) => {
        const payload = {
          status: enumChoice.returnStatuses.toKV().REVIEWED.value,
          request_ids: Array.from(selectedItems),
        }
        api.updateReturnRequesStatusBulk(payload).then((response) => {
          toast.success("Return request status updated successfully");
          fetchReturnRequest();
        }, (error) => {
          toast.error("Failed to update return request status");
        })
      },
    },
    {
      label: 'Reject Selected',
      onClick: (selectedItems:any) => {
        const payload = {
          status: enumChoice.returnStatuses.toKV().REJECTED.value,
          request_ids: Array.from(selectedItems),
        }
        api.updateReturnRequesStatusBulk(payload).then((response) => {
          toast.success("Return request status updated successfully");
          fetchReturnRequest();
        }, (error) => {
          toast.error("Failed to update return request status");
        })
      },
    },
    {
      label: 'Cancel Selected',
      onClick: (selectedItems:any) => {
        const payload = {
          status: enumChoice.returnStatuses.toKV().CANCELLED.value,
          request_ids: Array.from(selectedItems),
        }
        api.updateReturnRequesStatusBulk(payload).then((response) => {
          toast.success("Return request status updated successfully");
          fetchReturnRequest();
        }, (error) => {
          toast.error("Failed to update return request status");
        })
      },
    },
  ];


  // Define columns with render functions for custom content
  const columns = [
    { header: "ID", key: "id", render: (item: any) => (
        <button onClick={() => setOpenReturnOrderDetails(item.id)}>
          <p className="text-sm font-normal text-base-300 mt-1">#RID{item.id}</p>
        </button>
      )},
    { header: "Order ID", key: "order", render: (item: any) => (
      <button onClick={() => setOpenOrderDetails(item.order_alias)} >
        <p className="text-sm font-normal text-base-300 mt-1">#OID{item.order}</p>
      </button>
    )},
    { header: "Requested At", key: "created_at", render: (item: any) => (
      moment(item.created_at).format("MMMM D, YYYY h:mm A")
    )},
    { header: "Initiated by", key: "initiated_by" },
    { header: "Approved by", key: "reviewed_by" },
    { header: "reviewed by", key: "reviewed_by" },

    { header: "Payment Method", key: "payment_method", render: (item: any) => (
      <TextBadge value={item.payment_method} label={getEnumLabel(enumChoice.paymentMethods, item.payment_method)} />
    )},
    { header: "Status", key: "status", render: (item: any) => (
      <TextBadge value={item.status} label={getEnumLabel(enumChoice.returnStatuses, item.status)} />
    )},
    { header: "Reason", key: "reason", render: (item: any) => (
        <TextBadge value={item.status} label={getEnumLabel(enumChoice.returnReasons, item.reason)} />
    )},
    { header: "Reason Details", key: "reason_details" },
  ];

  return (
    <div className="relative overflow-x-auto">
      <GenericSelectableTable columns={columns} data={returnRequests} bullkActionButtons={bullkActionButtons} />

      {/* Order details modal */}
      {openOrderDetails && (
        <OrderDetails isOpen={openOrderDetails ? true : false} onClose={() => setOpenOrderDetails(null)} alias={openOrderDetails} />
      )}
        
        {/* Return order details modal */}
      {openReturnOrderDetails && (
        <ReturnOrderDetails isOpen={openReturnOrderDetails ? true : false} onClose={() => setOpenReturnOrderDetails(null)} id={openReturnOrderDetails} />
      )}
      
    </div>
  );
}

export default ReturnRequestTable;
